import { shortLangCode } from '../adapters/live-speech-adapter'
import type { ViewerLanguageItem } from '@/modules/speech-translation/api/viewer'
import { isLangSttSupported } from '@/modules/speech-translation/utils/lang-stt-supported'

/**
 * 从 session 源/目标语列表解析某监听/发言短码是否支持 STT。
 * 缺条目时默认 true（兼容旧 session 未带 sttSupported）。
 */
export function resolveListenSttSupported(
  listenCode: string,
  session: { source: ViewerLanguageItem; targets: ViewerLanguageItem[] },
): boolean {
  const short = shortLangCode(listenCode)
  if (!short) {
    return true
  }
  const candidates = [session.source, ...session.targets]
  const hit = candidates.find(
    (item) =>
      shortLangCode(item.languageCode) === short
      || shortLangCode(item.languageCode2 || '') === short,
  )
  if (!hit) {
    return true
  }
  return isLangSttSupported(hit)
}
